import { NgClass, NgTemplateOutlet } from "@angular/common";
import {
    Component,
    contentChild,
    Input,
    TemplateRef,
    ChangeDetectionStrategy
} from "@angular/core";

@Component({
    selector: "rask-toggle-list-item",
    templateUrl: "./toggle-list-item.component.html",
    styleUrls: ["./toggle-list-item.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        NgClass,
        NgTemplateOutlet
    ]
})
export class ToggleListItemComponent {
    @Input() expanded = false;
    @Input() locked = false;
    protected readonly templateRef = contentChild(TemplateRef);

    toggle = () => this.expanded = this.locked ? this.expanded : !this.expanded;
}
